export function formatEventDate(dateStr: string): string {
  const date = new Date(dateStr);

  return new Intl.DateTimeFormat("fr-FR", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  })
    .format(date)
    .replace(/^\w/, (c) => c.toLowerCase()); // met la première lettre en minuscule
}